import { render, staticRenderFns } from "./GroupSummary.vue?vue&type=template&id=cffe4a16&scoped=true&"
import script from "./GroupSummary.vue?vue&type=script&lang=js&"
export * from "./GroupSummary.vue?vue&type=script&lang=js&"
import style0 from "./GroupSummary.vue?vue&type=style&index=0&id=cffe4a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffe4a16",
  null
  
)

export default component.exports